export { SecureCheckoutBadge } from './secure-checkout-badge';
